// Textos customizados localizados. Acrescente novos idiomas nesta pasta.
import { PT_BR } from './pt-BR';
import { FR } from './fr';

export type UiStrings = typeof PT_BR;

export function getUiStrings(): UiStrings {
    const language = localStorage.getItem('language');
    return language === 'fr' ? FR : PT_BR;
}
